import React from 'react';
import { Grid, Button, IconButton, Tooltip } from '@mui/material';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import Filtro from 'components/Filtro/Filtro';

const PerguntaActions = ({ handleFiltroChange, openVisualizarModal, openModal }) => {
  return (
    <Grid container justifyContent="flex-end" alignItems="center" style={{ marginBottom: '20px' }}>
      <Tooltip title="Pesquisar Pergunta">
        <span>
          <Filtro onFiltroChange={handleFiltroChange} />
        </span>
      </Tooltip>
      <Tooltip title="Visualizar Perguntas">
        <span>
          <IconButton onClick={openVisualizarModal}>
            <VisibilityIcon color="primary" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Cadastrar Perguntas">
        <span>
          <Button variant="contained" color="primary" onClick={() => openModal('novo')}>
            + NOVA
          </Button>
        </span>
      </Tooltip>
    </Grid>
  );
};

export default PerguntaActions;
